const types = {
  SET_DESK: "SET_DESK",
  SET_IDENTIFICATION_TYPE: "SET_IDENTIFICATION_TYPE",
  SET_CLIENT_DATA: "SET_CLIENT_DATA",
  SET_YEARS_OLD_BY_DATE: "SET_YEARS_OLD_BY_DATE",
  SET_ACTIVITIE: "SET_ACTIVITIE",
  SET_PAYMENT_BILL: "SET_PAYMENT_BILL",
  SET_CONTACT_MEAN: "SET_CONTACT_MEAN",
  SET_PRICE_VALUE_TO_SOLICITATE: "SET_PRICE_VALUE_TO_SOLICITATE",
  SET_LINE_OF_CREDIT: "SET_LINE_OF_CREDIT",
  SET_VALUE_FIELDS_OF_FINANCES: "SET_VALUE_FIELDS_OF_FINANCES",
  SET_IDENTIFICATION: "SET_IDENTIFICATION",
  SET_SIMULATION: "SET_SIMULATION",
  SET_SIMULATION1: "SET_SIMULATION1",
  SET_CREDIT_CHECKBOX: "SET_CREDIT_CHECKBOX",
  SET_FIELDS: "SET_FIELDS",
  ADD_FIELD: "ADD_FIELD",
  SET_DEFAULT_CREDIT: "SET_DEFAULT_CREDITS",
  SET_DEFAULT_INPUT: "SET_DEFAULT_INPUT",
  SET_FECHA_NASCIMENTO: "SET_FECHA_NASCIMENTO",
  SET_COMPLETE_NAME: "SET_COMPLETE_NAME",
  SET_DAYS_OF_INITIAL_INTEREST: "SET_DAYS_OF_INITIAL_INTEREST",
  SET_MONTO: "SET_MONTO",
  SET_RATE: "SET_RATE",
  SET_DEADLINE: "SET_DEADLINE",
  SET_SAVED_SIMULATION: "SET_SAVED_SIMULATION",
  SET_CREDIT_DESTINATION: "SET_CREDIT_DESTINATION",
  SET_SELECTED_STATE: "SET_SELECTED_STATE",
  SET_SELECTED_CITY: "SET_SELECTED_CITY",
  SET_EDUCATIONAL_LEVEL: "SET_EDUCATIONAL_LEVEL",
  SET_TAKER_GENDER: "SET_TAKER_GENDER",
  SET_EXTRACT: "SET_EXTRACT,",
  SET_PRODUCT: "SET_PRODUCT",
  SET_TASA: "SET_TASA",
  SET_CONTRACT_TYPE: "SET_CONTRACT_TYPE",
  SET_PRODUCT1: "SET_PRODUCT1",
  SET_PRICING: "SET_PRICING",
  SET_DOMINIO_CORREO: "SET_DOMINIO_CORREO",
  SET_DESTINO_CREDITO: "SET_DESTINO_CREDITO",
  SET_SELECTED_PAIS: "SET_SELECTED_PAIS",
  SET_SELECTED_DEPARTAMENTO: "SET_SELECTED_DEPARTAMENTO",
  SET_SELECTED_CIUDAD: "SET_SELECTED_CIUDAD",
  ADD_IDENTITY_PHOTO_FILE: "ADD_IDENTITY_PHOTO_FILE",
  SET_ID_TYPE: "SET_ID_TYPE",
}

export default types
